// RU: своя копия детекта телефона по UA — пакет `pascal-slots-core` экспортирует только `Frame`
//     (правило владельца 05.10); регулярка та же, что у ядра (helpers/isMobile).
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
